export const blackFilterIcon = require("../assets/black_filter_icon.svg");
export const blackSearchIcon = require("../assets/black_search_icon.svg");
export const whiteFilterIcon = require("../assets/white_filter_icon.svg");
export const whiteSearchIcon = require("../assets/white_search_icon.svg");
export const whiteLeftArrowIcon = require("../assets/white_left_arrow_icon.svg");
export const blackLeftArrowIcon = require("../assets/black_left_arrow_icon.svg");
export const dummyprofile=require("../assets/pfp.png");
export const noresults=require("../assets/noresults.png");
